import { useContext, useEffect, useState } from 'react';
import './App.css';
import Main from './components/Main';
import Login from './components/Login';
import NotFound from './components/NotFound';
import PrivecyCode from './components/PrivecyCode'
import Register from './components/Register'
import PersonData from './components/PersonData'
import RequestInsurance from './components/RequestInsurance'
import PaymentResult from './components/PaymentResult'
import { ToastContainer } from "react-toastify";
import { Routes, Route } from "react-router-dom"
export default function App() {

  useEffect(() => {

  }, [])

  return (
    <>
      <ToastContainer
        bodyClassName={() => "myToastClass"}
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={true}
        rtl={true}
      />
      <Routes>
        <Route path='/RequestInsurance' element={<RequestInsurance />}/>
        <Route path='/' element={<Main />} />
        <Route path='/PaymentResult' element={<PaymentResult />} />
        
        <Route path='/main' element={<Main />} />
        <Route path='/login' element={<Login />} />
        <Route path='/privecycode' element={<PrivecyCode />} />
        <Route path='/register' element={<Register />} />
        <Route path='/PersonData' element={<PersonData />} />
        
        
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

